export const jobassign = (job, status) => {
console.log('assigning job' +job);
  return {
      type: "JobAssign",
      payload : {
        job : job,
        status :status
      }
  }
};



// WEBPACK FOOTER //
// ./src/actions/job-assign.js